window.addEventListener('DOMContentLoaded', () => {
    //Get UTM Parameters
    const checkUTMParams = JSON.parse(localStorage.getItem('utm_params'));
    if (!checkUTMParams) {
        const url_string = window.location.href
        let url = new URL(url_string);
        const utm_campaign = url.searchParams.get("utm_campaign");
        const utm_content = url.searchParams.get("utm_content");
        const utm_medium = url.searchParams.get("utm_medium");
        const utm_source = url.searchParams.get("utm_source");
        const utm_term = url.searchParams.get("utm_term");

        const data = {
            'utm_campaign': `${utm_campaign}`,
            'utm_content': `${utm_content}`,
            'utm_medium': `${utm_medium}`,
            'utm_source': `${utm_source}`,
            'utm_term': `${utm_term}`
        }
        localStorage.setItem('utm_params', JSON.stringify(data));
    }
});

function openChatWidget() {
    GorgiasChat.open();
    const btn = document.querySelector('.gorgias-chat-key-eam2gc');
    btn.style.display = "block";
}

// Lessen to cart change Start
document.addEventListener('rebuy:cart.change', (event) => { 
    console.log('rebuy:cart.change event', event.detail); 
        //Set Order Attributes
        $.getJSON('/cart.js', function (cart) {
        
            const cartItems = cart.items;
            for(i=0;i<=cartItems.length-1;i++){
                const filterItems = cartItems[i].selling_plan_allocation;
                if(filterItems != undefined ){
                    setPurchaseTypeLabel(cartItems[i].selling_plan_allocation.selling_plan.name, i);
                }else{
                    setPurchaseTypeLabel('One-time Purchase', i);
                }
            }
        });
  });
function setPurchaseTypeLabel(textLabel, index){
    const parentElement = document.querySelectorAll('.rebuy-cart__flyout-item-variant-title');
    const textLabelElement = document.createElement('span');
    textLabelElement.innerHTML = `<br>${textLabel}`;
    textLabelElement.style.fontWeight = '500';
    if(parentElement[index].querySelector('span')){
        parentElement[index].querySelector('span').remove();
    }
    parentElement[index].appendChild(textLabelElement);

}

  // Lessen to cart change Start


